export const LANGS = ["ru", "kz"];
